import { RadioGroup, Switch } from '@affine/component';
import { EditorSettingService } from '@affine/core/modules/editor-setting';
import { useI18n } from '@affine/i18n';
import { useLiveData, useService } from '@toeverything/infra';

export const LinkFaviconsSwitch = () => {
  const t = useI18n();
  const { editorSetting } = useService(EditorSettingService);
  const enabled = useLiveData(
    editorSetting.settings$.selector(s => s.showLinkFavicons)
  );
  return (
    <Switch
      data-testid="show-link-favicons"
      aria-label={t['com.affine.settings.link-favicons.title']()}
      checked={enabled}
      onChange={enabled => editorSetting.set('showLinkFavicons', enabled)}
    />
  );
};

export const LinkFaviconProviderSelect = () => {
  const t = useI18n();
  const { editorSetting } = useService(EditorSettingService);
  const provider = useLiveData(
    editorSetting.settings$.selector(s => s.linkFaviconProvider)
  );
  return (
    <div
      role="group"
      aria-label={t['com.affine.settings.link-favicons.provider.title']()}
    >
      <RadioGroup
        value={provider}
        items={[
          {
            value: 'google',
            label: 'Google',
            testId: 'link-favicon-provider-google',
          },
          {
            value: 'affine',
            label: 'AFFiNE',
            testId: 'link-favicon-provider-affine',
          },
        ]}
        onChange={provider => {
          if (provider === 'google' || provider === 'affine') {
            editorSetting.set('linkFaviconProvider', provider);
          }
        }}
      />
    </div>
  );
};
